<script>
export default {
  props: {
    value: {
      type: [Boolean, String, Number],
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    typeInput: {
      type: String,
      default: "checkbox"
    },
    name: {
      type: String,
      default: "check"
    }
  }
};
</script>

<template>
  <div
    :class="[
      {
        'checked-input': value,
        'disabled-input': disabled
      },
      typeInput
    ]"
  >
    <input
      :checked="value"
      :disabled="disabled"
      class="input"
      :type="typeInput"
      :name="name"
      @change="$emit('input', typeInput === 'radio' ? value : !value)"
      @click="$emit('change', $event)"
    />
    <div
      class="label"
      :class="{
        'label--checked': value,
        'label--disabled': disabled
      }"
    />
  </div>
</template>

<style lang="scss" scoped>
@import "~@/styles/variables";

.checkbox {
  position: relative;
  display: inline-block;
  width: 18px;
  height: 18px;

  .input {
    opacity: 0;
    display: block;
    position: relative;
    z-index: 100;
    width: 100%;
    height: 100%;

    &:checked + .label {
      background: $color-medium-grey url("~@/assets/icons/checked.svg") center no-repeat;
      background-size: 9px 9px;
    }

    &:disabled + .label {
      opacity: 0.2;
    }

    &:not(:disabled) {
      cursor: pointer;
    }
  }

  .label {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border: 2px solid $color-medium-grey;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 2px;
    transition: all 0.2s;
  }
}
.radio {
  position: relative;
  display: inline-block;
  width: 20px;
  height: 20px;

  .input {
    opacity: 0;
    display: block;
    position: relative;
    z-index: 100;
    width: 100%;
    height: 100%;

    &:checked + .label {
      border-color: #000;
      &::after {
        position: absolute;
        width: 10px;
        height: 10px;
        background: #333333;
        border-radius: 50%;
        content: "";
        left: 3px;
        top: 3px;
      }
    }

    &:disabled + .label {
      opacity: 0.2;
    }

    &:not(:disabled) {
      cursor: pointer;
    }
  }
  .label {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border: 2px solid $color-medium-grey;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 50%;
    transition: all 0.2s;
  }
}
</style>
